export var SIZE_MAP = {
  xlarge: 'xl',
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  xl: 'xl',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};
export var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs', 'def'];
export var IGNORE_SIZE = ['xs', 'def'];